export const isValueSelected = (
  selectedValues: string | string[] | null | undefined,
  value: string,
): boolean =>
  Array.isArray(selectedValues)
    ? selectedValues.includes(value)
    : value === selectedValues;
